import FuTableColumnSelect from "./FuTableColumnSelect";

FuTableColumnSelect.install = function (Vue) {
  Vue.component(FuTableColumnSelect.name, FuTableColumnSelect);
};

export default FuTableColumnSelect;
